import React, { useState, useEffect } from "react";
import { fetchFilteredGuides, fetchGuideTypes, fetchGuideCountries } from "./utils";

const genders = [
  { label: "Any", value: "" },
  { label: "Female", value: "female" },
  { label: "Male", value: "male" },
];

const ages = [
  { label: "Any", value: "" },
  { label: "18-25", value: "18-25" },
  { label: "26-35", value: "26-35" },
  { label: "36-50", value: "36-50" },
  { label: "51-65", value: "51-65" },
  { label: "65+", value: "over_65" }
];



const GuideFilter = ({ onFilter, onClose, initialValues }) => {
  const [age, setAge] = useState(initialValues?.age || "");
  const [gender, setGender] = useState(initialValues?.gender || "");
  const [archetype, setArchetype] = useState(initialValues?.archetype || "");
  const [country, setCountry] = useState(initialValues?.country || "");
  const [archetypes, setArchetypes] = useState([{ label: "Any", value: "" }]);
  const [countriesList, setCountriesList] = useState([{ label: "Any", value: "" }]);

  useEffect(() => {
    setAge(initialValues?.age || "");
    setGender(initialValues?.gender || "");
    setArchetype(initialValues?.archetype || "");
    setCountry(initialValues?.country || "");
  }, [initialValues?.age, initialValues?.gender, initialValues?.archetype, initialValues?.country]);
  
  useEffect(() => {
    let isMounted = true;
    fetchGuideCountries().then(countries => {
      if (!Array.isArray(countries)) return;
      const opts = countries.map(c => ({ label: c, value: c }));
      if (isMounted) setCountriesList([{ label: "Any", value: "" }, ...opts]);
    });
    return () => { isMounted = false; };
  }, []);

  useEffect(() => {
    let isMounted = true;
    fetchGuideTypes().then(types => {
      if (!Array.isArray(types)) return;
      const opts = types.map(t => ({ label: t.title, value: t.hyphenated_title }));
      if (isMounted) setArchetypes([{ label: "Any", value: "" }, ...opts]);
    });
    return () => { isMounted = false; };
  }, []);


  const handleSubmit = async (e) => {
    e.preventDefault();
    // Build query params from filters
    const params = new URLSearchParams();
    if (age) params.append('age', age);
    if (gender) params.append('gender', gender);
    if (archetype) params.append('archetype', archetype);
    if (country) params.append('country', country);

    try {
      const res = await fetchFilteredGuides(params)
      // Expecting data.guides or data as array
      onFilter(res.guides || res);
    } catch (err) {
      // Optionally handle error, e.g. show a message
      onFilter([]);
    }
    if (onClose) onClose();
  };

  return (
    <div className="guide-filter-modal-overlay">
      <form className="guide-filter-modal-box" onSubmit={handleSubmit}>
        <h2>Filter Guides</h2>
        <label>
          Age:
          <select value={age} onChange={e => setAge(e.target.value)}>
            {ages.map(a => <option key={a.value} value={a.value}>{a.label}</option>)}
          </select>
        </label>
        <label>
          Gender:
          <select value={gender} onChange={e => setGender(e.target.value)}>
            {genders.map(g => <option key={g.value} value={g.value}>{g.label}</option>)}
          </select>
        </label>
        <label>
          Archetype:
          <select value={archetype} onChange={e => setArchetype(e.target.value)}>
            {archetypes.map(a => <option key={a.value} value={a.value}>{a.label}</option>)}
          </select>
        </label>
        <label>
          Country:
          <select value={country} onChange={e => setCountry(e.target.value)}>
            {countriesList.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
          </select>
        </label>
        <div className="guide-filter-modal-actions">
          <button type="button" onClick={onClose}>Cancel</button>
          <button type="submit">Apply</button>
        </div>
      </form>
    </div>
  );
};

export default GuideFilter;
